// extracted by mini-css-extract-plugin
module.exports = {"textYellow":"TextYellowTitleComponent--textYellow--l1gdxqh"};